// extracted by mini-css-extract-plugin
export var bannerActions = "cookie-consent-module--bannerActions--34a06";
export var cookieBanner = "cookie-consent-module--cookieBanner--78857";
export var dBlock = "cookie-consent-module--d-block--3be45";
export var dFlex = "cookie-consent-module--d-flex--084df";
export var dLgBlock = "cookie-consent-module--d-lg-block--525a5";
export var dLgFlex = "cookie-consent-module--d-lg-flex--bdd77";
export var dLgNone = "cookie-consent-module--d-lg-none--b923e";
export var dMdBlock = "cookie-consent-module--d-md-block--17bd1";
export var dMdFlex = "cookie-consent-module--d-md-flex--eda0b";
export var dMdNone = "cookie-consent-module--d-md-none--d45ec";
export var dNone = "cookie-consent-module--d-none--07bf2";